import ProgramContext from './modules/ProgramContext';
import ProgramsSettings from './modules/ProgramsSettings';

export default {
  namespaced: false,
  modules: {
    ProgramsSettings,
    ProgramContext,
  },
};
